import { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import QuotationReplyPage from './QuotationReplyPage';
import { useLocation } from 'react-router-dom';
import { withRouter, WithRouterProps } from '../../../../utils/withRouter';;
import { RootState, Dispatch } from '../../../../state/store/store';
import { QuotationPublicDetails } from '../../../../sdk/controllers/bids/IBids';
import Loader from '../../../shared/SmallComponents/Loader';
import { localizationSelectors } from '../../../../state/ducks/localization/selectors';
import ExceptionPage from '../../../../components/pages/ExceptionPage/ExceptionPage';
import { getUrlFuncType } from '../../../shared/FilesPreview/Preview';
import { businessPartnersSelectors } from '../../../../state/ducks/businessPartner/selectors';
import { settings } from '../../../../models/entities/businessPartner/businessPartner';

type RouteParams = {
    bidToken: string;
};

type Props = WithRouterProps<RouteParams> & {
    fetchByToken: (token: string) => Promise<QuotationPublicDetails>;
    createQuotation: (formData: FormData, isPublic?: boolean) => Promise<boolean>;
    fetchError?: string;
    localization: any;
    quotationGetFile: getUrlFuncType;
    companySettings: settings;
};

const QuotationReplyPageConnected = ({
    params,
    fetchByToken,
    localization,
    createQuotation,
    fetchError,
    quotationGetFile,
    companySettings
}: Props) => {
    const location = useLocation();
    const [data, setData] = useState<QuotationPublicDetails | undefined>();
    const bidToken = params.bidToken;
    useEffect(() => {
        if (bidToken) {
            fetchByToken(bidToken)
                .then((d) => {
                    setData(d);
                })
                .catch(() => {});
        }
    }, [bidToken]);
    useEffect(() => {
        if (location?.state?.quotationPublicDetails) {
            setData(location.state.quotationPublicDetails);
        }
    }, [location]);

    if (fetchError) {
        let error = { message: undefined, status: 500 };
        try {
            error = JSON.parse(fetchError);
        } catch (e) {}
        return <ExceptionPage status={error.status} title={error.message || localization.reply_page_default_error_message} />;
    }
    if (!data) return <Loader />;
    return (
        <>
            <QuotationReplyPage
                data={data}
                localization={localization}
                createQuotation={createQuotation}
                quotationGetFile={quotationGetFile}
                isPublic={!!bidToken}
                companySettings={companySettings}
            />
        </>
    );
};

const mapStateToProps = (state: RootState) => ({
    localization: localizationSelectors.quotation(state),
    fetchError: state.error.effects.bids.fetchByToken,
    companySettings: businessPartnersSelectors.settingsByLanguage(state)
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
    fetchByToken: (token: string) => dispatch.bids.fetchByToken(token) as unknown as Promise<QuotationPublicDetails>,
    createQuotation: (formData: FormData, isPublic?: boolean) => dispatch.bids.createQuotation({ formData, isPublic }) as unknown as Promise<boolean>,
    quotationGetFile: (fileId: string, bidId: string, partyId: string, isPublic?: boolean) =>
        dispatch.bids.quotationGetFile({ fileId, bidId, partyId, isPublic }) as unknown as ReturnType<getUrlFuncType>
});

export default withRouter<any, RouteParams>(connect(mapStateToProps, mapDispatchToProps)(QuotationReplyPageConnected));
